export default __webpack_public_path__ + "static/media/get-started-arrows.fe0223bf.svg";